import { strLang } from "../../functions/strLang";
import StdButton from "../../components/StdButton";
import { CircularProgress } from "@mui/material";

export default function InactiveScreen({ status, openActivity }) {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ width: 320, paddingBottom: 30 }}>
        {strLang("activeGroup")}
      </div>
      {status ? (
        <CircularProgress size={24} />
      ) : (
        <StdButton label={strLang("activate")} onClick={openActivity} />
      )}
    </div>
  );
}
